// violet variant of the buc MenuSelect items, pass it as `menuItemSx`
export const violetMenuItemSx = {
  padding: "5px 8px",
  "&:hover, &.Mui-focusVisible": {
    backgroundColor: "var(--soft-violet)",
  },
  "&:active": {
    backgroundColor: "var(--medium-violet)",
    color: "var(--grey-2)",
  },
  "&.Mui-selected": {
    backgroundColor: "var(--soft-violet)",
    "&:focus": {
      backgroundColor: "var(--soft-violet)",
    },
    "&:active": {
      backgroundColor: "var(--medium-violet)",
    },
  },
} as const;
